import { Form, Spin } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import {
  ButtonLocal,
  Text,
} from 'modules/Onboarding/Register/CourseTraining/style'
import {
  AdjustIcon,
  SpinWrapper,
} from 'modules/Onboarding/Register/Education/style'
import CourseForm from 'modules/Onboarding/Register/ProjectInternship/Project'
import { SubHeading1 } from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import React, { Fragment, useEffect, useState } from 'react'
import { searchConfig } from 'utils/config'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'


const CourseTraining = ({
  setCurrent,
  studentData,
  studentFormData,
  updateStudentData,
  getListOfSkills,
  activeKey,
  cvDetails,
  getCorporateList,

  searchAPI,
  getDesignationsList,
  getFunctionsList,
  getIndustryList,
}) => {
  const [form] = Form.useForm()
  const [course, setCourse] = useState([])
  const [courseUpdated, setCourseUpdated] = useState([])

  const [skillLoading, setSkillLoading] = useState(true)
  const [loading, setLoading] = useState(true)
  const [isCvTrue, setIsCvTrue] = useState(false)
  const [allSkills, setAllSkills] = useState([])
  const [submitLoading, setSubmitLoading] = useState(false)
  const [updated, setUpdated] = useState(false)
  const [shown, setShown] = useState([])
   const [listOfAddedSkills, setListOfAddedSkills] = useState([]);
 
 
   const SkillsAPI = async search => {
     try {
       const results = await searchAPI( searchConfig?.skills?.name, search, searchConfig?.skills);
       let updatedSkills = results || [];
       const newSkill = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      };
     if (updatedSkills.length === 0 && search) {
       setListOfAddedSkills(prev => [...prev, newSkill]);
       updatedSkills = [newSkill, ...updatedSkills];
     }
     const isExactMatch = updatedSkills?.some(skill => skill?.name.toLowerCase() === search?.toLowerCase());
     if(updatedSkills?.length > 0 ){
       if(!isExactMatch && search?.length > 3){
         
         setListOfAddedSkills([...listOfAddedSkills,...updatedSkills])
         updatedSkills = [newSkill, ...updatedSkills];
       } else{
       updatedSkills = updatedSkills
 
       }
     }
       if (!allSkills?.length) {
         setAllSkills(updatedSkills)
       }
       setSkillLoading(false)
       return updatedSkills
     } catch (error) {
       setSkillLoading(false)
 
       console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
     }
   }
 

  useEffect(() => {
    SkillsAPI()
  }, [])

  useEffect(() => {
    let courseList = []

    let studentCvResume = cvDetails

    let studentCoursesDetails = studentFormData?.resume?.courses?.length
      ? studentFormData?.resume?.courses
      : studentCvResume?.courses || []
    if (
      studentFormData?.resume?.courses?.length <
        studentCvResume?.courses?.length &&
      !isCvTrue
    ) {
      setIsCvTrue(true)
    }
    studentCoursesDetails?.map((data, index) => {
      let formName = 'course_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          organization: data?.organization,
          title: data?.title,
          started_in: data?.started_in,
          ended_in: data?.ended_in,
          industry: data?.industry,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate?.size ? data?.certificate : {},
          awards: data?.awards,
          isDelete: false,
        },
      })
      return courseList.push({
        component: CourseForm,
        formName: formName,
      })
    })
    setCourseUpdated(courseList)
    setCourse(courseList)
    
    // Restore form data from localStorage if available
    const savedCourseData = localStorage.getItem(`courseTraining_${studentData?.id}`)
    if (savedCourseData) {
      try {
        const parsedCourseData = JSON.parse(savedCourseData)
        form.setFieldsValue(parsedCourseData)
      } catch (e) {
        console.error('Error parsing saved course/training data:', e)
      }
    }
    
    setLoading(false)
  }, [studentFormData])

  const courseHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())
    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'course_' + `${lastValue + 1}`

    arr.push({ component: CourseForm, formName: formName })
    if (isAdd) {
      setCourse([...courseUpdated, ...arr])
      setCourseUpdated([...courseUpdated, ...arr])
    }
    if (isDelete) {
      form.setFieldValue([[deleteForm], 'isDelete'], true)
      let updatedList = course?.filter(data => data?.formName !== deleteForm)

      setCourseUpdated(updatedList)
      // setCourse(updatedList)
    }
  }
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const submitHandler = async () => {
    let course = []
    const values = await form.getFieldValue()
    
    // Store form values in localStorage for persistence
    localStorage.setItem(`courseTraining_${studentData?.id}`, JSON.stringify(values))
    
    const errorList = []
    await form
      .validateFields()
      .then()
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('course') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          course.push({
            ...obj,
            awards: [],
          })
        }
      })

      let awardCourseData = []
      Object.entries(course).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (!obj?.certificate?.size) {
            delete obj?.certificate
          }
          if (name.includes('course_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardCourseData.push(load)
          }
        })
      })

      for (let i = 0; i < course.length; i++) {
        for (const [key, value] of Object.entries(awardCourseData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              course[i].awards.push(value1)
            }
          }
        }
      }
      if (cvDetails?.courses && cvDetails?.courses?.length) {
        studentFormData.student.cvDetails = {
          ...cvDetails,
          courses: course,
        }
      }
      course = course.map(proj => ({
        ...proj,
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }));
      setSubmitLoading(true)

      let payload = {
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student,
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
          ? studentFormData?.currentCourse
          : {},
        education: studentFormData?.education,
        resume: {
          ...studentFormData?.resume,
          courses: course,
        },
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        checkForApproval: true,
        checkDeleteSection: ["courses"],
      }
      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      studentFormData?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })

      payload?.resume?.courses.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0
        ) {
          delete payload?.resume?.courses[index]?.certificate
        }
      })
      let response = await updateStudentData(studentData?.id, payload)
      if (response === true) {
        SuccessMessage('Course and training saved successfully!')
        setSubmitLoading(false)
        setCurrent(activeKey + 1)
        setUpdated(true)
      } else {
        setSubmitLoading(false)
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  return (
    <Fragment>
      {!loading && !skillLoading ? (
        <>
          <Form
            scrollToFirstError
            onFinish={submitHandler && !updated}
            id={'courseForm'}
            form={form}
            layout="vertical"
          >
            {!!course.length &&
              course.map((obj, index) => {
                return (
                  <obj.component
                    key={index + 'course'}
                    form={form}
                    onRemove={courseHandler}
                    formName={obj?.formName}
                    studentFormData={studentFormData}
                    getListOfSkills={getListOfSkills}
                    skillLoading={skillLoading}
                    setSkillLoading={setSkillLoading}
                    getCorporateList={getCorporateList}
                    getDesignationsList={getDesignationsList}
                    getFunctionsList={getFunctionsList}
                    getIndustryList={getIndustryList}
                    SkillsAPI={SkillsAPI}
                    allSkills={allSkills}
                    isCvTrue={isCvTrue}
                    shown={shown}
                  />
                )
              })}
          </Form>
          <SubHeading1>Note:</SubHeading1>
          <SubHeading1>
            Please fill in all details in the section below to ensure exposure
            to maximum number of corporates
          </SubHeading1>
          <ButtonLocal onClick={() => courseHandler(true, false)}>
            <Control alignCenter gap="10px">
              <AdjustIcon>
                <AddIcon />
              </AdjustIcon>
              <Text>Add Courses & Training</Text>
            </Control>
          </ButtonLocal>
          {skillLoading && (
            <SpinWrapper center>
              <Spin />
            </SpinWrapper>
          )}
          <Control width="100%" flexEnd gap="15px" top="35px">
            <Button.Secondary
              text="Back"
              onClick={() => setCurrent(activeKey - 1)}
            />
            <Button.Primary
              text="Save & Continue"
              htmlType="submit"
              onClick={submitHandler}
              form={'courseForm'}
              disable={submitLoading}
            />
          </Control>
        </>
      ) : (
        <SpinWrapper center>
          <Spin />
        </SpinWrapper>
      )}
    </Fragment>
  )
}

export default CourseTraining
